module.exports = __webpack_public_path__ + "static/media/bg.2dedd0fa.png";